import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  WsFrameType_Text_getInstancea0n74vn6h277 as WsFrameType_Text_getInstance,
  WsProtocol2u70gp1eq7nu9 as WsProtocol,
} from './WsProtocol.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  mutableMapOfk2y3zt1azl40 as mutableMapOf,
  mapOf1xd03cq9cnmy8 as mapOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { withTimeout34v8nimvh0fh5 as withTimeout } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Timeout.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  toRequestParameters3ovu7e0943da8 as toRequestParameters,
  toMap14rbdrx2whbk6 as toMap,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/RequestParameters.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return null;
  }), 0);
}
var FactoryClass;
function Factory() {
  if (FactoryClass === VOID) {
    class $ {
      constructor(connectionAcknowledgeTimeoutMs, connectionPayload, frameType) {
        connectionAcknowledgeTimeoutMs = connectionAcknowledgeTimeoutMs === VOID ? 10000n : connectionAcknowledgeTimeoutMs;
        var tmp;
        if (connectionPayload === VOID) {
          tmp = SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b();
        } else {
          tmp = connectionPayload;
        }
        connectionPayload = tmp;
        frameType = frameType === VOID ? WsFrameType_Text_getInstance() : frameType;
        this.l6c_1 = connectionAcknowledgeTimeoutMs;
        this.m6c_1 = connectionPayload;
        this.n6c_1 = frameType;
      }
      h1() {
        return 'graphql-ws';
      }
      o6c(webSocketConnection, listener, scope) {
        var tmp0_connectionPayload = this.m6c_1;
        var tmp1_connectionAcknowledgeTimeoutMs = this.l6c_1;
        var tmp2_frameType = this.n6c_1;
        return new (SubscriptionWsProtocol())(webSocketConnection, listener, tmp1_connectionAcknowledgeTimeoutMs, tmp0_connectionPayload, tmp2_frameType);
      }
    }
    initMetadataForClass($, 'Factory', Factory);
    FactoryClass = $;
  }
  return FactoryClass;
}
function SubscriptionWsProtocol$_init_$slambda_7z3jff() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return null;
  }), 0);
}
function SubscriptionWsProtocol$connectionInit$slambda(this$0) {
  return constructCallableReference(($this$withTimeout, $completion) => orPromise($completion, function *($completion) {
    var map = yield* this$0.r6c($completion);
    var type = map.v4('type');
    var tmp;
    if (equals(type, 'connection_ack')) {
      return Unit_instance;
    } else if (equals(type, 'connection_error')) {
      throw ApolloNetworkException().r49('Connection error:\n' + toString_0(map));
    } else {
      println("unknown message while waiting for connection_ack: '" + toString(type));
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 1);
}
var SubscriptionWsProtocolClass;
function SubscriptionWsProtocol() {
  if (SubscriptionWsProtocolClass === VOID) {
    class $_0 extends WsProtocol() {
      constructor(webSocketConnection, listener, connectionAcknowledgeTimeoutMs, connectionPayload, frameType) {
        connectionAcknowledgeTimeoutMs = connectionAcknowledgeTimeoutMs === VOID ? 10000n : connectionAcknowledgeTimeoutMs;
        var tmp;
        if (connectionPayload === VOID) {
          tmp = SubscriptionWsProtocol$_init_$slambda_7z3jff();
        } else {
          tmp = connectionPayload;
        }
        connectionPayload = tmp;
        frameType = frameType === VOID ? WsFrameType_Text_getInstance() : frameType;
        super(webSocketConnection, listener);
        this.u6c_1 = connectionAcknowledgeTimeoutMs;
        this.v6c_1 = connectionPayload;
        this.w6c_1 = frameType;
      }
      *x6c($completion) {
        var message = mutableMapOf([to('type', 'connection_init')]);
        var payload = yield* $(this.v6c_1($completion), $completion);
        if (!(payload == null)) {
          message.b5('payload', payload);
        }
        this.y6c(message, this.w6c_1);
        yield* withTimeout(this.u6c_1, SubscriptionWsProtocol$connectionInit$slambda(this), $completion);
        return Unit_instance;
      }
      z6c(messageMap) {
        var tmp0_subject = messageMap.v4('type');
        if (equals(tmp0_subject, 'data')) {
          var tmp = messageMap.v4('id');
          var tmp_0 = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
          var tmp_1 = messageMap.v4('payload');
          this.q6c_1.d6d(tmp_0, (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE());
        } else if (equals(tmp0_subject, 'error')) {
          var id = messageMap.v4('id');
          if (!(id == null) ? typeof id === 'string' : false) {
            var tmp_2 = messageMap.v4('payload');
            this.q6c_1.c6d(id, (tmp_2 == null ? true : isInterface(tmp_2, KtMap())) ? tmp_2 : THROW_CCE());
          } else {
            var tmp_3 = messageMap.v4('payload');
            this.q6c_1.b6d((tmp_3 == null ? true : isInterface(tmp_3, KtMap())) ? tmp_3 : THROW_CCE());
          }
        } else if (equals(tmp0_subject, 'complete')) {
          var tmp_4 = messageMap.v4('id');
          this.q6c_1.a6d((!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : THROW_CCE());
        }
      }
      e6d(request) {
        this.y6c(mapOf([to('type', 'start'), to('id', request.h43_1.toString()), to('payload', toMap(toRequestParameters(request)))]), this.w6c_1);
      }
      h6b(request) {
        this.y6c(mapOf([to('type', 'stop'), to('id', request.h43_1.toString())]), this.w6c_1);
      }
    }
    initMetadataForClass($_0, 'SubscriptionWsProtocol', VOID, VOID, VOID, [0]);
    SubscriptionWsProtocolClass = $_0;
  }
  return SubscriptionWsProtocolClass;
}
//region block: exports
export {
  Factory as Factory2jyzsj2j7cj0z,
};
//endregion

//# sourceMappingURL=SubscriptionWsProtocol.mjs.map
